<template>
	<div
		:class="[
			'toggle',
			labelInsideClassName,
			isLabelBefore ? 'is-label-before' : ''
		]"
		:id="uid"
		:variant="variant"
	>
		<span
			ref="toogleTextRef"
			class="toggle__container"
			@focus="displayTooltip"
			@mouseover="displayTooltip"
			@mouseleave="hideTooltip"
		>
			<input
				aria-label="select the toggle to filter the list"
				class="toggle__input"
				name="toggle"
				type="checkbox"
				:checked="shouldBeChecked"
				:disabled="disabled"
				:icon="icon"
				:id="`${uid}_toggle`"
				:label="label"
				@change="changeInput"
			/>
			<span class="toggle__slider" :for="`${uid}_toggle`">
				<i :class="['icon', icon]"></i>
			</span>
			<label
				class="toggle__label-inside"
				:for="`${uid}_toggle`"
				v-if="labelInsideClassName"
			>
				<span class="option1"><slot name="true-value"></slot></span>
				<span class="option2"><slot name="false-value"></slot></span>
			</label>
		</span>
		<label :class="['toggle__label']" :for="`${uid}_toggle`" v-if="label">
			{{ label }}
		</label>

		<Tooltip
			v-if="tooltipText"
			:text="tooltipText"
			:display="showTooltip"
			:trackedRefName="'toogleTextRef'"
			:position="position !== 'top-start' ? position : 'top-start'"
			:offset="!offset.length ? [0, 4] : offset"
		/>
	</div>
</template>

<script>
import Tooltip from '@/components/shells/tooltip/tooltip';
export default {
	name: 'Toggle',
	components: {
		Tooltip
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		icon: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: Boolean,
			default: false
		},
		labelInsideClassName: {
			type: String,
			default: '' //toggle--label-in
		},
		isLabelBefore: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		tooltipText: {
			type: String,
			default: ''
		},
		position: {
			type: String,
			default: 'top-start',
			validator: function validator(value) {
				return (
					[
						'auto',
						'auto-start',
						'auto-end',
						'top',
						'top-start',
						'top-end',
						'bottom',
						'bottom-start',
						'bottom-end',
						'right',
						'right-start',
						'right-end',
						'left',
						'left-start',
						'left-end'
					].indexOf(value) > -1
				);
			}
		},
		offset: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showTooltip: false
		};
	},
	computed: {
		shouldBeChecked() {
			return this.value;
		}
	},
	methods: {
		changeInput(event) {
			this.$emit('change', event.target.checked);
		},
		displayTooltip() {
			this.showTooltip = true;
		},
		hideTooltip() {
			this.showTooltip = false;
		}
	}
};
</script>

<style lang="scss">
/**
    * [Description]
    * 
    * Global Switches
    * Can use SCSS variables = TRUE
    *
    * All switches styles and variations are included here.
    * 
    * [Table of Contents]
    *
    * BASE
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_form.scss';

.toggle {
	@include create-check-element('.toggle__input', 56px, 24px, 28px);
	position: relative;
	&.toggle--label-in {
		position: relative;
		@include create-check-element('.toggle__input', 68px, 24px, 28px);
		.toggle__input {
			~ .toggle__label-inside {
				display: flex;
				justify-content: space-between;
				position: absolute;
				padding: 12px;
				top: 50%;
				transform: translateY(-50%);
				width: 68px; //should match create-check-element mixin width value
				font-size: $switch-font-size;
				text-transform: uppercase;
				margin-left: 0;
				.option1 {
					@include quick-animation;
					opacity: 0;
				}
				.option2 {
					@include quick-animation;
				}
			}

			&:checked {
				border: $form-input-border--checked;
				background-color: $accent;
				+ .toggle__slider {
					left: 42px; //create-check-element mixin width value minus slider width
				}
				~ .toggle__label-inside {
					.option1 {
						opacity: 1;
					}
					.option2 {
						opacity: 0;
					}
				}
			}
			&:hover::after {
				border: $form-input-border-hover;
			}
		}
	}
	&.is-label-before {
		.toggle__container {
			order: 1;
			position: relative;
		}
	}
}

.toggle__input {
	&:checked {
		border: $form-input-border--checked;
		background-color: $accent;
		&:active,
		&:focus {
			background-color: $accent;
		}
		+ .toggle__slider {
			left: 30px; //create-check-element mixin width value minus slider width
		}
	}
	&:hover::after {
		border: $form-input-border-hover;
	}
}
.toggle__slider {
	position: absolute;
	cursor: pointer;
	left: 0;
	top: -1px;
	pointer-events: none;
	@include create-circle(26px, 26px, $white, $form-input-border);
	@include small-shadow;
	@include quick-animation;
	i {
		@include vertical-horizontal-center-with-transform;
	}
}
</style>
